import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { canv } from "@/canv/global";
import { MultiShapeIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UseShapeButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useShapeButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseShapeButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("shape"));

    const uniqueValues = [...new Set(options.map((option) => option.value))];
    const content =
        uniqueValues.length === 1 ? (
            canv.shapeStorage.getShape(uniqueValues[0] as string).getView()
        ) : (
            <MultiShapeIcon />
        );

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "shape" ? null : { name: "shape", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "shape";

    return {
        content,
        handleClick,
        isActive,
    };
}
